// src/components/MachineTable.js
import React from 'react';
import './Machanedteable.css';

const Powerunite = () => {
  const headers = [
    'Model',
    'BJ50-V6/S6',
    'BJ90-V6/S6',
    'BJ126-V6/S6',
    'BJ160-V6/S6',
    'BJ200-V6/S6',
  ];

const rows = [
    
    ['Hydraulic Pressure (MPa)', '17.5', '17.5', '17.5', '17.5', '17.5'],
    ['Pump Power (kW)', '7.5 / 10.7', '11 / 10.7', '11 / 13.2', '15 / 15.1', '18.5 / 20.4'],
    ['Heater Power (kW)', '3.5', '6', '6', '9.8', '11.5'],
  ];


  return (
    <div
      className="container"
      style={{ border: '1px solid lightgray', padding: 0, marginTop: 0 }}
    >
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th colSpan={headers.length} className="unit-row">
                Power Unit
              </th>
            </tr>
            <tr>
              {headers.map((head) => (
                <th key={head}>{head}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Powerunite;
